import { pathOr } from 'ramda'

export const selectHappyPathIncentive = state =>
  pathOr(null, ['happyPath', 'incentive'], state)

export const selectHappyPathDate = state =>
  pathOr(null, ['happyPath', 'date'], state)

export const selectHappyPathCutoff = state =>
  pathOr(null, ['happyPath', 'cutoff'], state)

export const selectHappyPathWeeksSinceFirstDelivery = state =>
  pathOr(null, ['happyPath', 'weeksSinceFirstDelivery'], state)
